/**
 * <tws-video-card> — poster image with a play/pause toggle over an inline video.
 *
 * Only one card plays at a time: starting one pauses every other card on the
 * page. Cards without a <video> child do nothing, so the markup degrades to a
 * plain image when a merchant hasn't attached a video.
 */
class TwsVideoCard extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.toggle = this.querySelector('[data-video-toggle]');

    if (!this.video || !this.toggle) return;

    this.onToggle = this.onToggle.bind(this);
    this.onEnded = this.onEnded.bind(this);

    this.toggle.addEventListener('click', this.onToggle);
    this.video.addEventListener('ended', this.onEnded);
    this.video.addEventListener('pause', this.onEnded);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.onToggle);
    this.video?.removeEventListener('ended', this.onEnded);
    this.video?.removeEventListener('pause', this.onEnded);
  }

  onToggle() {
    if (this.classList.contains('is-playing')) {
      this.stop();
      return;
    }

    document.querySelectorAll('tws-video-card.is-playing').forEach((card) => {
      if (card !== this) card.stop();
    });

    this.classList.add('is-playing');
    this.toggle.setAttribute('aria-pressed', 'true');
    this.video.play().catch(() => this.stop());
  }

  onEnded() {
    this.stop();
  }

  stop() {
    if (!this.video) return;
    this.classList.remove('is-playing');
    this.toggle?.setAttribute('aria-pressed', 'false');
    if (!this.video.paused) this.video.pause();
    this.video.currentTime = 0;
  }
}

if (!customElements.get('tws-video-card')) {
  customElements.define('tws-video-card', TwsVideoCard);
}
